









import { Component, Vue } from 'vue-property-decorator';
import { Getter, namespace } from 'vuex-class';
import UserManager from '@/services/user-manager/user-manager';
import WebSocketManager from '@/services/notifications/websocket-manager';
import loading from '@/components/loading.vue';

@Component({
  components: {
    loading,
  },
})
export default class App extends Vue {
  @Getter public isLoading!: boolean;

  public async mounted(): Promise<void> {

    // await UserManager.clearStaleState();

    // const user = await UserManager.getUser();
    // const isLoggedIn = user != null;

    // if ((!isLoggedIn || user.expired)) {
    //   await UserManager.signinRedirect();
    //   return;
    // }

    await WebSocketManager.startAsync();

    this.$store.commit('isLoading', false);
  }
}
